module.exports = __webpack_public_path__ + "static/25-01891ee8eea65b0810b92fe3d0564e97.png";